import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import millisToDate from 'utils/millisToDate'
import isBillesByName from 'utils/isBillesByName'
import isBilles from 'utils/isBilles'
import getRestrictions from 'utils/getRestrictions'
import buildNodePath from 'utils/buildNodePath'
import nameSort from 'utils/nameSort'

const groupsInEditMode = (node, groups, userGroup) => {
  return node.groups.sort(nameSort).reduce((acc, group, index) => {
    acc[`${index}`] = {
      label: group,
      selected: groups.indexOf(group) !== -1,
      pinned: userGroup.name === group || isBillesByName(group),
      hidden: isBillesByName(group) && !isBilles(userGroup)
    }
    return acc
  }, {})
}

const groupsInNoneEditMode = (groups, userGroup) => {
  return groups.sort(nameSort).reduce((acc, group, index) => {
    acc[`${index}`] = {
      label: group,
      selected: true,
      pinned: userGroup.name === group || isBillesByName(group),
      hidden: isBillesByName(group) && !isBilles(userGroup)
    }
    return acc
  }, {})
}

export default [
  function getMedia({ state, path }) {
    const mediaPath = state.get('media.currentFile')
    if (!mediaPath) {
      return path.revoke()
    }

    const media = state.get(mediaPath)

    return path.proceed({
      ...media
    })
  },
  {
    revoke: [],
    proceed: [
      function createForm({ props, state, path }) {
        const {
          id,
          name,
          resources,
          addedAt,
          metaData,
          node,
          groups,
          restriction,
          uploader
        } = props
        const restrictions = getRestrictions()

        if (!groups) return path.revoke()

        const {
          client: { resources: clientResources },
          user: { group, email }
        } = state.get('app')

        const validationRules = []
        const index = name.lastIndexOf('.')
        if (index !== -1) {
          validationRules.push(
            `endsWith:"${name.substring(index, name.length)}"`
          )
        }

        const form = {
          id: {
            value: id
          },
          name: {
            value: name,
            validationRules
          },
          path: {
            value: buildNodePath(node)
          },
          addedAt: {
            value: millisToDate(addedAt)
          },
          restriction: {
            type: {
              currentRestriction: restriction ? restriction.type : null,
              tags:
                restriction && restriction.type
                  ? {
                      '0': {
                        label: restriction.type,
                        selected: true,
                        key: Array.isArray(restrictions)
                          ? restrictions.reduce((acc, item) => {
                              if (item.label === restriction.type) {
                                acc = item.key
                              }
                              return acc
                            }, null)
                          : null
                      }
                    }
                  : {}
            },
            editModeType: {
              currentRestriction: restriction ? restriction.type : null,
              tags: restrictions.reduce((acc, item, index) => {
                acc[`${index}`] = {
                  label: item.label,
                  key: item.key,
                  selected: restriction
                    ? restriction.type === item.label
                    : false
                }
                return acc
              }, {})
            },
            email: {
              value:
                restriction && restriction.email ? restriction.email : email
            },
            message: {
              value:
                restriction && restriction.message ? restriction.message : ''
            }
          },
          metaData:
            metaData || uploader
              ? {
                  dpi: {
                    value: metaData ? metaData.dpi : ''
                  },
                  height: {
                    value: metaData ? metaData.height : ''
                  },
                  width: {
                    value: metaData ? metaData.width : ''
                  },
                  clippingPath: {
                    value: metaData ? metaData.clippingPath : ''
                  },
                  caption: {
                    value: metaData.caption || ''
                  },
                  uploader:
                    uploader && uploader.firstname
                      ? {
                          firstname: {
                            value: uploader.firstname
                          },
                          lastname: {
                            value: uploader.lastname
                          },
                          email: {
                            value: uploader.email
                          }
                        }
                      : ''
                }
              : null,
          resource: {
            value: '',
            isRequired: true
          },
          allGroups: groupsInEditMode(node, groups, group),
          groups: groupsInNoneEditMode(groups, group),
          resources: clientResources.reduce((acc, resource) => {
            acc[resource] =
              resources && resources[resource]
                ? resources[resource]
                    .sort(nameSort)
                    .reduce((acc, item, index) => {
                      acc[`${index}`] = {
                        label: item,
                        selected: true
                      }
                      return acc
                    }, {})
                : {}

            acc[resource].form = {
              isForm: true,
              value: '',
              isRequired: true
            }
            return acc
          }, {})
        }

        return path.proceed({
          form
        })
      },
      {
        revoke: [],
        proceed: [set(state`media.tags.form`, props`form`)]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/setTagsForm.js